import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { SearchTermservice } from '../../../services/search/search-service.service';
import { DueDiligenceService } from '../../../services/due-diligence/due-diligence.service';
import { DownloadService } from '../../../services/download/download.service'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, Sort } from '@angular/material';
import { DueDiligenceDeleteDialogComponent } from '../../../components/due-diligence-delete-dialog/due-diligence-delete-dialog.component';
import { DueDiligenceDialogComponent } from '../../../components/due-diligence-dialog/due-diligence-dialog.component';
import { PageEvent } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { ParDueDiligenceService } from '../../../services/par-due-diligence/par-due-diligence.service';
import { ParDueDiligenceDialogComponent } from '../par-due-diligence-dialog/par-due-diligence-dialog.component';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { ParDueDiligenceDeleteDialogComponent } from '../par-due-diligence-delete-dialog/par-due-diligence-delete-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-par-due-diligence',
  templateUrl: './par-due-diligence.component.html',
  styleUrls: ['./par-due-diligence.component.css']
})
export class ParDueDiligenceComponent implements OnInit {
  clientDisable: any;
  clientHidden: any;
  public role: string;
  listOfDocType: any;
  selectedDocumentType: any;
  noResults: any;
  length: any;
  sortedData;
  pageSize = 10;
  public dueDocs: any;
  ispaginationFlag: boolean = false;
  docCategory: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  documentsList;
  DocListErrMsg;
  DocListErr: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'FileEdit'];
  dataSource: MatTableDataSource<UserData>;
  uploadedFileName;
  placeholder = 'Select a Document';

  constructor(private parDueDiligenceService: ParDueDiligenceService, public dialog: MatDialog, ) { }

  ngOnInit() {
    this.uploadedFileName = 'PAR Due Diligence - ' + 'PAR North America'; 
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
    this.refresh();
  }
  placeholderChange(){
    this.placeholder = "Document";
  }
  refresh() {
    // List of Document types method
    this.parDueDiligenceService.listOfDocuments().subscribe(res => {
      if (res.DocumentTypes !== undefined && res.DocumentTypes.length <= 0) {
        this.DocTypeErrMsg = "No Document Types Found";
        this.DocTypeErr = true;
      } else {
        this.listOfDocType = res.DocumentTypes;
        this.docCategory = this.listOfDocType[0].Category;
      }
    }, err => {
      this.DocTypeErrMsg = 'PAR Due Diligence Service' + ' ' + err;
      this.DocTypeErr = true;
    });
    this.getDocDetails();
    this.parDueDiligenceService.load.subscribe(res => {
      if (res === 'success') {
        this.selectedDocumentType = '';
        this.getDocDetails();
      }
    });
  }

  getDocDetails() {
    this.parDueDiligenceService.getDocDetails().subscribe(res => {
      if (res.Documents !== undefined && res.Documents.length <= 0) {
        this.dueDocs = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.noResults = 'No documents found';
      } else {
        this.noResults = '';
        this.documentsList = res;
        this.dueDocs = this.documentsList.Documents;
        for (let i = 0; i < this.dueDocs.length; i++) {
          if (this.dueDocs[i].UploadedTimeStamp != '' && this.dueDocs[i].UploadedTimeStamp != null && this.dueDocs[i].UploadedTimeStamp != undefined) {
            var momentDate = moment(this.dueDocs[i].UploadedTimeStamp).format('YYYY/MM/DD');
            this.dueDocs[i].UploadedTimeStamp = momentDate;
          }
          if (this.dueDocs[i].ExpirationDate !== '' && this.dueDocs[i].ExpirationDate !== null && this.dueDocs[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.dueDocs[i].ExpirationDate).format('YYYY/MM/DD');
            this.dueDocs[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.dueDocs);
        this.dataSource.sort = this.sort;
        this.length = this.dueDocs.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.DocTypeErrMsg = 'PAR Due Diligence Service' + ' ' +  err;
      this.DocTypeErr = true;
    });
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  openDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;
    var new_Data = {
      DocumentTypeName: docName.DocumentTypeName,
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;
    let dialogRef = this.dialog.open(ParDueDiligenceDialogComponent, {
      width: '600px',
      height: '550px',
      data: { data: type === 'update' ? docName : new_Data, type: type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedDocumentType = '';
      this.placeholder = 'Select a Document';
    });
    localStorage.setItem('documentnName', docName);
  }

  editDoc(docName) {
    this.openDialog(docName, 'update');
    localStorage.setItem('old', JSON.stringify(docName));
  }

  doctypeChange(name) {
    this.openDialog(name, 'create');
  }

  deleteDoc(doc) {
    doc.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(ParDueDiligenceDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: doc
    });
  }

}
export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  FileEdit: any;
}


// WEBPACK FOOTER //
// ./src/app/components/par-due-diligence/par-due-diligence-documents/par-due-diligence.component.ts